import React, { useState, useEffect } from 'react';

const ProgressIndicator = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [activeSection, setActiveSection] = useState(0);

  const sections = [
    { id: 'platform', label: 'Платформа' },
    { id: 'features', label: 'Возможности' },
    { id: 'clients', label: 'Клиенты' },
    { id: 'pricing', label: 'Цены' },
    { id: 'demo', label: 'Демо' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement?.scrollHeight - window.innerHeight;
      const progress = (scrollTop / docHeight) * 100;
      setScrollProgress(progress);

      const sectionElements = sections?.map(section => ({
        id: section?.id,
        element: document.getElementById(section?.id),
      }));

      const scrollPosition = window.scrollY + 200;

      for (let i = sectionElements?.length - 1; i >= 0; i--) {
        const section = sectionElements?.[i];
        if (section?.element && section?.element?.offsetTop <= scrollPosition) {
          setActiveSection(i);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="fixed left-6 top-1/2 -translate-y-1/2 z-[10] hidden lg:block">
      <div className="relative">
        <div className="w-0.5 h-64 bg-muted rounded-full overflow-hidden">
          <div
            className="w-full bg-gradient-to-b from-primary via-accent to-secondary transition-all duration-300"
            style={{ height: `${scrollProgress}%` }}
          />
        </div>
        <div className="absolute top-0 left-0 w-0.5 h-64 flex flex-col justify-between">
          {sections?.map((section, index) => (
            <div
              key={section?.id}
              className="relative group cursor-pointer"
              onClick={() => {
                const element = document.getElementById(section?.id);
                if (element) {
                  const offset = 80;
                  const elementPosition = element?.offsetTop - offset;
                  window.scrollTo({
                    top: elementPosition,
                    behavior: 'smooth',
                  });
                }
              }}
            >
              <div
                className={`w-2 h-2 rounded-full -ml-0.75 transition-all duration-300 ${
                  activeSection === index
                    ? 'bg-primary scale-150 neon-glow-primary' :'bg-muted-foreground/50 hover:bg-muted-foreground'
                }`}
              />
              <div className="absolute left-4 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
                <div className="glassmorphism px-3 py-1.5 rounded-lg whitespace-nowrap">
                  <span className="text-xs font-medium text-foreground">{section?.label}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgressIndicator;